// ============================================
// FILE 1: /frontend/src/api/bookmarks.api.js
// PURPOSE: Bookmarks API endpoints
// ============================================

import apiClient from './client.js';

export const bookmarksAPI = {
  // Get user's bookmarks
  getUserBookmarks: async (userId) => {
    const response = await apiClient.get(`/bookmarks/user/${userId}`);
    return response.data;
  },

  // Check if listing is bookmarked
  checkBookmark: async (listingId) => {
    const response = await apiClient.get(`/bookmarks/check/${listingId}`);
    return response.data;
  },

  // Create bookmark
  createBookmark: async (listingId, notes = '') => {
    const response = await apiClient.post('/bookmarks', { listingId, notes });
    return response.data;
  },

  // Update bookmark notes
  updateBookmark: async (bookmarkId, notes) => {
    const response = await apiClient.patch(`/bookmarks/${bookmarkId}`, { notes });
    return response.data;
  },

  // Delete bookmark
  deleteBookmark: async (bookmarkId) => {
    const response = await apiClient.delete(`/bookmarks/${bookmarkId}`);
    return response.data;
  },

  // Batch check bookmarks
  checkBookmarksBatch: async (listingIds) => {
    const response = await apiClient.post('/bookmarks/check-batch', { listingIds });
    return response.data;
  },
};